import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { PieChartWorker } from './pie-chart.worker';

/**
 * PortfolioMonitorPieChartWorker: plain chart worker specific to a Pie Chart used in Portfolio Monitoring.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class PortfolioMonitorPieChartWorker extends PieChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
	}

	public transformData(): void {
		this.config.colors = [];
		this.config.series = this.highChartsAttributes.customAttributes;
	}

	public updateData(data: Array<any>): void {
		this.chart.series[0].setData(data);
	}
}
